// import external dependencies
import 'custom-event-polyfill';
import 'jquery';
import 'popper.js';
import 'bootstrap-sass';
import 'slick-carousel';
import 'magnific-popup';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import warenkorb from './routes/cart';
import benutzerkonto from './routes/myaccount';
import kassa from './routes/checkout';
import standorte from './routes/standorte';
import uebergaben from './routes/handovers';


/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // Cart page
  warenkorb,
  // myaccount page
  benutzerkonto,
  // checkout page
  kassa,
  standorte,
  uebergaben,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());




// WEBPACK FOOTER //
// ./scripts/main.js